// Each section here is the list of navigational items of the child menu from the meganav
import { hasVenueSetupBeenCompleted } from '../../../utils/venue/venue';
//const enquiriesNavChildren = [{ title: "View Enquiries", route: "" }, { title: "Widget Editor", route: "widget"}]

// const iqosNavChildren = [
//     {title: "Trials", route: "trials"},
//     {title: "Leads", route: "leads"},
//     {title: "Add Lead", route: "add-lead"}
// ]

const setupPage = {
  title: 'Setup',
  root: 'setup',
  icon: 'check_circle_outline',
};
const liveBookingsPage = {
  title: 'Order & Pay',
  root: 'live',
  icon: 'live_tv',
};
const completedOrdersPage = {
  title: 'Completed',
  root: 'completed',
  icon: 'assignment_turned_in',
};
const userManagementPage = {
  title: 'Users',
  root: 'users',
  icon: 'person',
};
const financialPage = {
  title: 'Finances',
  root: 'financial',
  icon: 'account_balance',
};
const menusPage = { title: 'Menus', root: 'menus', icon: 'restaurant_menu' };
const salesPage = { title: 'Stats', root: 'sales', icon: 'equalizer' };
const newVenuePage = {
  title: 'Create Venue',
  root: 'create-venue',
  icon: 'add_circle_outline',
};
const multiVenuePage = {
  title: 'Multi-Venue',
  root: 'multi-venue',
  icon: 'storefront',
};
// const marketingPage = {
//   title: 'Events',
//   root: 'marketing',
//   icon: 'campaign',
// };
const clientsPage = { title: 'Clients', root: 'clients', icon: 'people_alt' };

const bookings = {
  title: 'Reservations',
  root: 'bookings',
  icon: 'calendar_month',
};
// // IQOS is a special case - we've revoked complications at this moment, it's simple again
// const iqosPage = {title: "IQOS", root: "iqos", children: iqosNavChildren, iconImage: "iqos"}

// Each item in the array here displays an icon on the left hand side tab menu
const navigationElementsSetupCompleted = [
  setupPage,
  bookings,
  liveBookingsPage,
  completedOrdersPage,
  menusPage,
  salesPage,
  financialPage,
  multiVenuePage,
  clientsPage,
  userManagementPage,
  newVenuePage,
];
const navigationElementsSetupNeeded = [
  setupPage,
  bookings,
  liveBookingsPage,
  completedOrdersPage,
  menusPage,
  salesPage,
  financialPage,
  multiVenuePage,
  clientsPage,
  userManagementPage,
  // marketingPage,
  newVenuePage,
];

export const navigationElementsForVenue = venue => {
  if (hasVenueSetupBeenCompleted(venue)) {
    return navigationElementsSetupCompleted;
  } else {
    return navigationElementsSetupNeeded;
  }
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/MegaNav/navigation.js